import { render, staticRenderFns } from "./ScannerStamps.vue?vue&type=template&id=c7b503b0&scoped=true&"
import script from "./ScannerStamps.vue?vue&type=script&lang=js&"
export * from "./ScannerStamps.vue?vue&type=script&lang=js&"
import style0 from "./ScannerStamps.vue?vue&type=style&index=0&id=c7b503b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b503b0",
  null
  
)

export default component.exports